import { Card } from "@mui/material";

import { CardHeader } from "./CardHeader";
import UsersTable from "./Table/UsersTable";

// ----------------------------------------------------------------------

export const UsersCard = () => {
	return (
		<Card sx={{ maxWidth: 900, pb: 3 }}>
			<CardHeader />
			<UsersTable />
		</Card>
	);
};

export default UsersCard;
